export default __webpack_public_path__ + "static/carbon-d54fdb266e7b08b4b736db99f9f2a5b3.jpg";